import { FormattedMessage } from 'react-intl';

import { Chart2, ClipboardText, Activity, KeyboardOpen, SearchStatus, Setting, Wifi, Warning2, MessageText1 } from 'iconsax-react';

const icons = {
  feedback: MessageText1,
  reporting: Warning2,
  wifi: Wifi,
  setting: Setting,
  inspect: SearchStatus,
  evaluation: KeyboardOpen,
  analytics: Activity,
  scorecard: ClipboardText,
  dashboard: Chart2
};

const modules = {
  id: 'group-modules',
  // title: <FormattedMessage id="modules" />,
  type: 'group',
  icon: icons.CarryOutOutlined,
  children: [
    {
      id: 'dashboard',
      title: <FormattedMessage id="dashboard" />,
      type: 'item',
      url: '/dashboard',
      icon: icons.dashboard
    },
    {
      id: 'scorecard',
      title: <FormattedMessage id="scorecard" />,
      type: 'item',
      url: '/scorecard',
      // breadcrumbs: true,
      icon: icons.scorecard
    },
    {
      id: 'analytics',
      title: <FormattedMessage id="analytics" />,
      type: 'item',
      url: '/analytics',
      icon: icons.analytics
    },
    {
      id: 'evaluation',
      title: <FormattedMessage id="evaluation" />,
      type: 'item',
      url: '/evaluation',
      icon: icons.evaluation
    },
    {
      id: 'inspect',
      title: <FormattedMessage id="inspect" />,
      type: 'item',
      url: '/inspect',
      icon: icons.inspect
    },
    // {
    //   id: 'livecall',
    //   title: <FormattedMessage id="livecall" />,
    //   type: 'item',
    //   url: '/livecall',
    //   icon: icons.wifi
    // },
    {
      id: 'reporting',
      title: <FormattedMessage id="reporting" />,
      type: 'item',
      url: '/reporting',
      icon: icons.reporting
    },
    {
      id: 'feedback',
      title: <FormattedMessage id="feedback" />,
      type: 'item',
      url: '/feedback',
      icon: icons.feedback
    },
    {
      id: 'settings',
      title: <FormattedMessage id="settings" />,
      type: 'item',
      url: '/settings',
      icon: icons.setting
    }
  ]
};

export default modules;
